import * as React from "react";
import DataComponent from "../common/DataComponent";
import MiniSpinner from "../common/MiniSpinner";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import YesNoComponent from "../common/YesNoComponent";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';


class FavoritedLabel extends DataComponent {

    constructor(props) {
        super(props);
        this.state = {
            hovering: false,
            processing: false, 
            showModal: false, 
            modalText: null, 
            yesFunction: null, 
            noFunction: null, 
            yesParameter: null
        };
        this.onHover = this.onHover.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.removeProvider = this.removeProvider.bind(this);
        this.addProvider = this.addProvider.bind(this);
        this.stopProcessing = this.stopProcessing.bind(this);
        this.removeProviderClick = this.removeProviderClick.bind(this);
        this.closeDialog = this.closeDialog.bind(this);

    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        //logUI("MBHWeb.UI.FavoritedLabel.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onHover() {
        const { hovering } = this.state;
        if (!hovering) {
            this.setState({ hovering: true });
        }
    }

    onMouseOut() {
        const { hovering } = this.state;
        if (hovering) {
            this.setState({ hovering: false });
        }
    }

    addProvider(npi, event) {
        event.preventDefault();
        event.stopPropagation();
        const { NPI, addProviderToFavorites } = this.props;
        const { processing } = this.state;
        if (!processing) {
            //debugger;
            this.setState({ processing: true });
        }
        addProviderToFavorites(npi, this.stopProcessing);
        this.props.requestDirectNpiList();
        logUI("MBHWeb.Settings.Favorite.Add", new Date(), Tools.getURLPath());
        return false;
    }

    removeProviderClick(npi, event) {
        event.preventDefault();
        event.stopPropagation();
        const { showModal } = this.state;
        if (!showModal) {
            this.setState({
                showModal: true,
                modalText: "Are you sure you want to remove<br />this provider from your favorites?",
                yesFunction: this.removeProvider,
                noFunction: this.closeDialog,
                yesParameter: npi
            });
        }
        return false;
    }

    closeDialog() {
        const { showModal } = this.state;
        if (showModal && this._isMounted) {
            this.setState({ showModal: false });
        }
    }

    removeProvider(npi) {
        const { removeFavoriteProvider } = this.props;
        const { processing } = this.state;
        this.closeDialog();
        if (!processing) {
            //debugger;
            this.setState({ processing: true });
        }
        removeFavoriteProvider(npi, this.stopProcessing);
        logUI("MBHWeb.Settings.Favorite.Remove", new Date(), Tools.getURLPath());
    }

    stopProcessing() {
        const { processing } = this.state;
        if (processing && this._isMounted) {
            this.setState({ processing: false, hovering: false });
        }
    }

    render() {
        const { hovering, processing, showModal, modalText, yesFunction, noFunction, yesParameter } = this.state;
        const { NPI, IsFavorited, fetching, isProxyUser } = this.props;
        const isMobile = Tools.isMobile();
        if (isProxyUser) { return "" };
        return (
            <React.Fragment>
                <YesNoComponent showModal={showModal} modalText={modalText} modalYesFunction={yesFunction} modalNoFunction={noFunction} YesParameter={yesParameter} />
            <div className="docs__info-container--fav favoritedlabel" onMouseOver={this.onHover} onMouseOut={this.onMouseOut} >
                {processing ?
                    <MiniSpinner />
                        :
                    isMobile ? 
                            IsFavorited ?
                                <div className="details-icon-prepend" onClick={(e) => this.removeProviderClick(NPI, e)}>
                                    <div className="icon-col"><span className="isFavorited icon-favorite" /></div>
                                    <div className="details-col"><span className="favLabel"> Favorited</span></div>
                                </div>
                                :
                                <div className="details-icon-prepend" onClick={(e) => this.addProvider(NPI, e)}>
                                    <div className="icon-col"><span className="icon-favorite isNotFavorited" /></div>
                                    <div className="details-col"><span className="favLabel"> Add To Favorites</span></div>
                            </div>
                    :
                    IsFavorited ?
                        !hovering ?
                            <div className="details-icon-prepend">
                                    <div className="icon-col"><span className="isFavorited icon-favorite" /></div>
                                    <div className="details-col"><span className="favLabel"> Favorited</span></div>
                            </div>
                            :
                                <div className="details-icon-prepend hover" onClick={(e) => this.removeProviderClick(NPI, e)}>
                                        <div className="icon-col"><span className="icon-remove-favorite isNotFavorited" /></div>
                                        <div className="details-col favLabel"><span className="favLabel"> Remove</span></div>
                            </div>
                        :
                        !hovering ?
                                    <div className="details-icon-prepend">
                                        <div className="icon-col"><span className="icon-favorite isNotFavorited" /></div>
                                        <div className="details-col"><span className="favLabel"> Add To Favorites</span></div>
                            </div>
                            :
                                    <div className="details-icon-prepend hover" onClick={(e) => this.addProvider(NPI, e)}>
                                        <div className="icon-col"><span className="icon-favorite isFavorited" /></div>
                                        <div className="details-col"><span className="favLabel"> Add To Favorites</span></div>
                            </div>
                }
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { NPI } = ownProps;
    return {
        isLoggedIn: state.domain.li,
        FavoriteProviders: state.healthSource.arrayFavoriteNPIs,
        fetching: state.healthSource.fetchingFavoriteProviders,
        IsFavorited: state.healthSource.arrayFavoriteNPIs && state.healthSource.arrayFavoriteNPIs.length > 0 ? state.healthSource.arrayFavoriteNPIs.find((npi) => { return npi === NPI; }) : false,
        isProxyUser: state.domain.ip
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addProviderToFavorites: (npi, completionCallback) => {
            dispatch({
                type: types.ADD_FAVORITE_PROVIDER_START,
                npi: npi,
                completionCallback: completionCallback
            });
        },
        removeFavoriteProvider: (npi, completionCallback) => {
                dispatch({
                    type: types.REMOVE_FAVORITE_PROVIDER_START,
                    npi: npi,
                    completionCallback: completionCallback
                });
        },
        requestDirectNpiList: () => { dispatch({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST }); }
        };
};

export default connect(mapStateToProps, mapDispatchToProps)(FavoritedLabel);

